
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();


@Component({ name: "etap", components: { } })
export default class WykrojnikTitleVue extends Vue {
}

